import { jsx, jsxs } from "react/jsx-runtime";
import { cleanProps, cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { buttonVariants } from "./Button.variants.js";
function Button({ children, className, disabled, iconLeft, iconRight, loading, buttonType = 'button', ...props }) {
    const { buttonSlot, textSlot, iconSlot } = buttonVariants({
        ...props,
        disabled: disabled || loading
    });
    const iconSlotClasses = iconSlot();
    const iconSize = 'sm' === props.size || 'md' === props.size ? '20' : '24';
    return /*#__PURE__*/ jsxs("button", {
        type: buttonType,
        className: cn(buttonSlot(), className),
        ...cleanProps(props, [
            'type',
            'shadow',
            'fullWidth'
        ]),
        disabled: disabled || loading,
        "aria-busy": loading,
        children: [
            loading && /*#__PURE__*/ jsx(CdnIcon, {
                className: cn('animate-spin', iconSlotClasses),
                iconName: "refresh",
                size: iconSize
            }),
            iconLeft && /*#__PURE__*/ jsx(CdnIcon, {
                iconName: iconLeft,
                className: iconSlotClasses,
                size: iconSize
            }),
            /*#__PURE__*/ jsx("span", {
                className: textSlot(),
                children: children
            }),
            iconRight && /*#__PURE__*/ jsx(CdnIcon, {
                iconName: iconRight,
                className: iconSlotClasses,
                size: iconSize
            })
        ]
    });
}
export { Button };
